angular.module('env.data.services',
    [
        'env.data.services.auth',
        'env.data.services.permissions',
        'env.data.services.ping',
        'env.data.services.omqlAliasBuilder',
        'env.data.services.gridDataProvider',
        'env.data.services.loginShadowService',
        'env.data.services.gridTextSearch'
    ])
;